import en from './locales/en.json' with {type:'json'};
import { formatMessage, type AppLocale } from './core';
export * from './core';
const cache=new Map<AppLocale,Record<string,string>>([['en',en]]);
const loaders={
 'zh-Hans':()=>import('./locales/zh-Hans.json'), 'zh-Hant':()=>import('./locales/zh-Hant.json'),
 es:()=>import('./locales/es.json'),fr:()=>import('./locales/fr.json'),de:()=>import('./locales/de.json'),
 'pt-BR':()=>import('./locales/pt-BR.json'),ja:()=>import('./locales/ja.json'),ko:()=>import('./locales/ko.json'),ar:()=>import('./locales/ar.json'),
};
const requests=new Map<AppLocale,Promise<void>>();
export async function loadLanguage(locale:AppLocale){
 if(cache.has(locale))return;
 let request=requests.get(locale);
 if(!request){request=loaders[locale as keyof typeof loaders]().then(module=>{cache.set(locale,module.default);}).finally(()=>requests.delete(locale));requests.set(locale,request);}
 await request;
}
export function translate(locale:AppLocale,key:string,values?:Record<string,string|number>){ return formatMessage(cache.get(locale)?.[key] ?? (en as Record<string,string>)[key] ?? key,values); }
export function plural(locale:AppLocale,key:string,count:number){ return translate(locale,`${key}.${new Intl.PluralRules(locale).select(count)}`,{count:new Intl.NumberFormat(locale).format(count)}); }
